import request from "../../../../helper/request";

const driverFeedbackApi = {
  getDriverFeedbacks: (params) => {
    return request.get("/admin/driver-feedbacks", params);
  }
};

export default driverFeedbackApi;
